import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import hmwquestion from "../../assets/Images/hmwquestion.jpg";





const WorkClient = () => {
    const navigate = useNavigate();

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Fontys Marketing</h1>
                <p>During this semster I will work for Fontys Marketing for my group project</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-client">
                    <div className="content-work-client-text">
                    {/* <img src={gif2}></img> */}
                        <h1>What do we do after?</h1>
                        <p>We finally got our client for the project which is the Fontys Marketing, </p>
                        <p>We did a brainstorm on what we could do for our client, and I come up with most of the HMW (How Might We question)</p>
                        <p>My group leader thought about using guerilla marketing to help our client, and I thought that
                            this would be a good idea
                        </p>
                    </div>

                    <div className="content-work-client-image">
                        <img src={hmwquestion}></img>
                    </div>

                    <div className="content-work-client-text2">
                        <h1>We come up with a theme</h1>
                        <p>We got an idea for our campaign to use meme, why meme? personally I did a research 
                            on how meme could benefit us on marketing this campaign, because our target audience is basically us,
                            we often get attracted to trends and a meme is one of the way we could attract the audience to see what 
                            we want to share.
                        </p>
                        <p>
                            My group came up with an Idea to use cat meme for this campaign, although I disagree at first I now see 
                            the potential to market our campaign with this. This campaign could be fun, interesting, and different with cat meme 
                            as theme.
                        </p>
                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default WorkClient;